<template>
</template>

<script>
export default {
  name: 'nuttrema-index-list-button-add-new',
};
</script>



// WEBPACK FOOTER //
// src/components/ui/list/nuttrema-index-list-button-add-new.vue